export default {
  advertisement: {},
};



// WEBPACK FOOTER //
// ./src/app/advertisements/store/state.js